import { render, staticRenderFns } from "./StatusFieldtype.vue?vue&type=template&id=f967f558&"
import script from "./StatusFieldtype.vue?vue&type=script&lang=js&"
export * from "./StatusFieldtype.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports